document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents) => {
  const amount = cents / 100;
  // Format with commas, show decimals only if needed
  const formatted = amount % 1 === 0 
    ? amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `LE ${formatted}`;
};

  const initCard = (card) => {
    const variantsJSON = card.querySelector('[data-product-variants-json]');
    if (!variantsJSON) return;

    let variants;
    try {
      variants = JSON.parse(variantsJSON.textContent.trim());
    } catch (e) {
      console.error('Invalid variant JSON', e);
      return;
    }

    const radios = card.querySelectorAll('.product-card-variant-option input[type="radio"]');
    if (!radios.length) return;

    const img = card.querySelector('lazy-image img, .card-gallery img, [data-card-image]');
    const priceEl = card.querySelector('[data-card-price]');
    const compareEl = card.querySelector('[data-card-compare-price]');
    const skuEl = card.querySelector('[data-card-sku]');
    const linkEl = card.querySelector('.product-card__link');
    const productHandle = card.dataset.productHandle;

    let currentVariant = variants[0];

    const updateCard = () => {
      const selected = {};
      card.querySelectorAll('.product-card-variant-option').forEach((fieldset) => {
        const index = parseInt(fieldset.dataset.optionIndex, 10);
        const checked = fieldset.querySelector('input:checked');
        if (checked) selected[`option${index}`] = checked.value;
      });

      let variant = variants.find(v =>
        (!selected.option1 || v.option1 === selected.option1) &&
        (!selected.option2 || v.option2 === selected.option2) &&
        (!selected.option3 || v.option3 === selected.option3)
      );

      if (!variant) variant = variants[0];
      currentVariant = variant;

      // 🖼️ Image
      if (img && variant.image) {
        img.src = variant.image;
        img.srcset = variant.image;
        img.dataset.src = variant.image;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.alt = variant.title;
        console.log('✅ Updated visible image element');
      }

      // 💰 Price
      if (priceEl && variant.price) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      // 🔢 SKU
      if (skuEl) skuEl.textContent = variant.sku || '';

      // 🔗 Update product link
      if (linkEl && productHandle) {
        linkEl.href = `/products/${productHandle}?variant=${variant.id}`;
      }

      console.log(`✅ Updated variant → ${variant.title}`);
    };

    // Update on variant change
    radios.forEach(radio => radio.addEventListener('change', updateCard));

    // Navigate when clicking image or title
    [img, linkEl].forEach(el => {
      if (!el) return;
      el.addEventListener('click', (e) => {
        if (!currentVariant || !productHandle) return;
        const targetUrl = `/products/${productHandle}?variant=${currentVariant.id}`;
        console.log('➡️ Redirecting to', targetUrl);
        window.location.href = targetUrl;
        e.preventDefault();
      });
    });
  };

  document.querySelectorAll('product-card[data-product-id]').forEach(initCard);
});
